$(function() {

    var domMaster = null;
    var domMe = null;
    var domNode2 = null;
    var domNode3 = null;
    var validNavigation = false;
    var dataConnections = [];
    var callTo = {
        from: null,
        callTo1: null,
        callToStatus1: null,
        callTo2: null,
        callToStatus2: null,
    };

    function updateMessage(data) {
        console.log('Received1', data);
        if (data.message === 'disconnect') {
            if (callTo.callTo1 === data.userId && domNode2) {
                domNode2.classList.add('offline');
                domNode2.querySelector('video').remove();
            } else if (callTo.callTo2 === data.userId && domNode3) {
                domNode3.classList.add('offline');
                domNode3.querySelector('video').remove();
            }
            removeConnection(data.userId);
        }
    }

    function addConnection(userId, connection) {
        dataConnections = dataConnections.filter(function(item) {
            return item.userId !== userId;
        });
        dataConnections.push({id: userId, connection: connection});
    }

    function removeConnection(userId) {
        dataConnections = dataConnections.filter(function(item) {
            return item.userId !== userId;
        });
    }

    function sendMessage(message) {
        dataConnections.forEach(function(item) {
            item.connection.send({
                userId: callTo.from,
                message: message
            });
        });
    }

    function call(callsDOM, myPeer, userId, stream, callback = null) {
        var call = myPeer.call(userId, stream);
        call.on('stream', stream => {
            addStreamToDOM(callsDOM, userId, stream);
            if (callback) {
                callback(stream);
            }
        });

        call.on('close', () => {
            console.log('offline2: ' + userId);
            removeStreamToDOM(userId);
            call.close();
        });

        var conn = myPeer.connect(userId, {
            metadata: {
                userId: callTo.from
            }
        });
        conn.on('open', function() {
            conn.on('data', function(data) {
                updateMessage(data);
            });
        });
        addConnection(userId, conn);

        window.onbeforeunload = function() {
            // if (!validNavigation) {
            //     call.close();
            // }
            sendMessage('disconnect');
        };
    }

    function addStreamToDOM(callsDOM, userId, stream, me = false) {
        callsDOM.classList.remove('offline');
        callsDOM.classList.remove('connecting');
        var video = Array.from(document.querySelectorAll('video')).filter(e => e.dataset.userId === userId).shift();
        if (!video) {
            var video = document.createElement('video');
            video.dataset.userId = userId;
            callsDOM.append(video);
        }

        if (me) {
            video.muted = true;
        }

        video.srcObject = stream
        video.addEventListener('loadedmetadata', () => {
            video.play()
        })
    }

    function removeStreamToDOM(userId) {
        var video = Array.from(document.querySelectorAll('video')).filter(e => e.dataset.userId === userId).shift();
        if (!video) {
            return;
        }
        video.remove();
    }

    $('[data-call-close]').on('click', function() {
        // window.location.href="/";
        $('body').addClass('is-loading');
        sendMessage('disconnect');
        setTimeout(function() {
            window.location.href = "/";
        }, 300);
    });

    $('meta[name=patient_url]').each(function() {
        var url = this.content;
        function fetchData() {
            fetch(url)
                .then(response => response.json())
                .then(function(response) {
                    update(response);
                });
        }
        function update(response) {
            if (!response.ok) {
                return;
            }
            var data = response.data;
            // console.log(data);

            updateFieldIfChange('heart-rate', data.heart_rate);
            updateFieldIfChange('blood-pressure', data.blood_pressure);
            updateFieldIfChange('temperature', data.temperature);
            updateFieldIfChange('blood-saturation', data.blood_saturation);
            updateFieldIfChange('weight', data.weight);
            updateFieldIfChange('blood-glucose', data.blood_glucose);
            updateFieldIfChange('cholesterol', data.cholesterol);
            updateFieldIfChange('ketone', data.ketone);
            updateFieldIfChange('lactate', data.lactate);
            updateFieldIfChange('uric-acid', data.uric_acid);
        }
        function updateFieldIfChange(key, data) {
            var $field = $('[data-'+key+']');
            if ($field.length === 0) {
                return;
            }
            var field = $field.get(0);
            var valueNow = $('span:nth-child(3) > span', field).html();

            if (valueNow != data.value_for_humans) {
                $('span:nth-child(3)', field).css('display', '');
                $field.addClass('chat-patient__item--has-new-value');
                setTimeout(function() {
                    $field.removeClass('chat-patient__item--has-new-value');
                }, 1200);
            }

            $('span:nth-child(2) > span', field).html(data.time_pass);
            $('span:nth-child(3) > span', field).html(data.value_for_humans);
        }
        setInterval(function() {
            fetchData();
        }, 5000);
    });

    $('[data-call]').each(function() {
        // Get element
        var wrapper = this;

        domMaster = $('[data-call-master]').get(0);
        domMe = $('[data-call-me]').get(0);
        domNode2 = $('[data-call-node2]').get(0);
        domNode3 = $('[data-call-node3]').get(0);

        var me = $('[name=me]', wrapper).attr('content');
        var number = parseInt($('[name=number]', wrapper).attr('content'));
        var node1Code = $('[name=node1_code]', wrapper).attr('content');
        var node1Status = $('[name=node1_status]', wrapper).attr('content');
        var node2Code = $('[name=node2_code]', wrapper).attr('content');
        var node2Status = $('[name=node2_status]', wrapper).attr('content');
        var node3Code = $('[name=node3_code]', wrapper).attr('content');
        var node3Status = $('[name=node3_status]', wrapper).attr('content');

        if (number < 3) {
            domNode3.style.display = 'none';
        }

        if ("node1" === me) {
            callTo = {
                from: node1Code,
                callTo1: node2Code,
                callToStatus1: node2Status,
                callTo2: node3Code,
                callToStatus2: node3Status
            };
        } else if ("node2" === me) {
            callTo = {
                from: node2Code,
                callTo1: node1Code,
                callToStatus1: node1Status,
                callTo2: node3Code,
                callToStatus2: node3Status
            };
        } else if ("node3" === me) {
            callTo = {
                from: node3Code,
                callTo1: node1Code,
                callToStatus1: node1Status,
                callTo2: node2Code,
                callToStatus2: node2Status
            };
        } else {
            return;
        }

        var myPeer = new Peer(callTo.from, {
            host: 'app.idicare.com',
            secure: true,
            port: 443,
            path: '/peerjs',
            config: {
                'iceServers': [
                    { url: 'stun:stun01.sipphone.com' },
                    { url: 'stun:stun.ekiga.net' },
                    { url: 'stun:stun.fwdnet.net' },
                    { url: 'stun:stun.ideasip.com' },
                    { url: 'stun:stun.iptel.org' },
                    { url: 'stun:stun.rixtelecom.se' },
                    { url: 'stun:stun.schlund.de' },
                    { url: 'stun:stun.l.google.com:19302' },
                    { url: 'stun:stun1.l.google.com:19302' },
                    { url: 'stun:stun2.l.google.com:19302' },
                    { url: 'stun:stun3.l.google.com:19302' },
                    { url: 'stun:stun4.l.google.com:19302' },
                    { url: 'stun:stunserver.org' },
                    { url: 'stun:stun.softjoys.com' },
                    { url: 'stun:stun.voiparound.com' },
                    { url: 'stun:stun.voipbuster.com' },
                    { url: 'stun:stun.voipstunt.com' },
                    { url: 'stun:stun.voxgratia.org' },
                    { url: 'stun:stun.xten.com' },
                    {
                        url: 'turn:numb.viagenie.ca',
                        credential: 'muazkh',
                        username: 'webrtc@live.com'
                    },
                    {
                        url: 'turn:192.158.29.39:3478?transport=udp',
                        credential: 'JZEOEt2V3Qb0y27GRntt2u2PAYA=',
                        username: '28224511:1379330808'
                    },
                    {
                        url: 'turn:192.158.29.39:3478?transport=tcp',
                        credential: 'JZEOEt2V3Qb0y27GRntt2u2PAYA=',
                        username: '28224511:1379330808'
                    }
                ]
            }
        });

        navigator.mediaDevices.getUserMedia({
            video: {
                width: { ideal: 640 },
                height: { ideal: 320 },
                facingMode: "user"
            },
            audio: true
        }).then(stream => {

            // myPeer.on('open', id => {
            //     // console.log('open', id);
            // });

            myPeer.on('connection', function(conn) {
                addConnection(conn.metadata.userId, conn);
                conn.on('data', function(data) {
                    updateMessage(data);
                });
            });

            myPeer.on('disconnected', () => {
                console.log('disconnected');
                setTimeout(function() {
                    location.reload();
                }, 5000);
            });

            myPeer.on('error', (err) => {
                console.log('error: ' + err);
                setTimeout(function() {
                    location.reload();
                }, 5000);
            });

            myPeer.on('call', call => {
                // console.log('call', call);

                var userId = call.peer;
                call.answer(stream);

                call.on('stream', stream => {
                    // console.log('new stream from user', userId);
                    // if (userId === callTo.callTo2) {
                    //     addStreamToDOM(domNode2, userId, stream);
                    // } else {
                    //     addStreamToDOM(domNode3, userId, stream);
                    // }

                    if ("node1" == me) {
                        if (userId === node2Code) {
                            addStreamToDOM(domNode2, userId, stream);
                            if (number < 3) {
                                addStreamToDOM(domMaster, 'master', stream, true);
                            }

                            $('[data-call-src]').removeClass('chat-call__video--is-active');
                            $(domNode2).addClass('chat-call__video--is-active');
                        }
                        if (userId === node3Code) {
                            addStreamToDOM(domNode3, userId, stream);
                        }
                    } else if ("node2" == me) {
                        if (userId === node1Code) {
                            addStreamToDOM(domNode2, userId, stream);
                            if (number < 3) {
                                addStreamToDOM(domMaster, 'master', stream, true);
                            }

                            $('[data-call-src]').removeClass('chat-call__video--is-active');
                            $(domNode2).addClass('chat-call__video--is-active');
                        }
                        if (userId === node3Code) {
                            addStreamToDOM(domNode3, userId, stream);
                        }
                    } else if ("node3" == me) {
                        if (userId === node2Code) {
                            addStreamToDOM(domNode2, userId, stream);
                        }
                        if (userId === node1Code) {
                            addStreamToDOM(domNode3, userId, stream);
                            if (number < 3) {
                                addStreamToDOM(domMaster, 'master', stream, true);
                            }

                            $('[data-call-src]').removeClass('chat-call__video--is-active');
                            $(domNode3).addClass('chat-call__video--is-active');
                        }
                    }
                });

                call.on('close', () => {
                    console.log('offline1: ' + userId);
                    removeStreamToDOM(userId);
                    call.close();
                });

                window.onbeforeunload = function() {
                    if (!validNavigation) {
                        call.close();
                    }
                };
            });

            addStreamToDOM(domMe, callTo.from, stream, true);
            if ("node1" == me) {
                if ("enter" === node2Status) {
                    call(domNode2, myPeer, node2Code, stream, function(stream) {
                        if (number < 3) {
                            addStreamToDOM(domMaster, 'master', stream, true);
                        }
                        $('[data-call-src]').removeClass('chat-call__video--is-active');
                        $(domNode2).addClass('chat-call__video--is-active');
                    });
                }
                if (number > 2 && "enter" === node3Status) {
                    call(domNode3, myPeer, node3Code, stream);
                }
            } else if ("node2" == me) {
                if ("enter" === node1Status) {
                    call(domNode2, myPeer, node1Code, stream, function(stream) {
                        if (number < 3) {
                            addStreamToDOM(domMaster, 'master', stream, true);
                        }
                        $('[data-call-src]').removeClass('chat-call__video--is-active');
                        $(domNode2).addClass('chat-call__video--is-active');
                    });
                }
                if (number > 2 && "enter" === node3Status) {
                    call(domNode3, myPeer, node3Code, stream);
                }
            } else if ("node3" == me) {
                if ("enter" === node1Status) {
                    call(domNode3, myPeer, node1Code, stream, function(stream) {
                        if (number < 3) {
                            addStreamToDOM(domMaster, 'master', stream, true);
                        }
                        $('[data-call-src]').removeClass('chat-call__video--is-active');
                        $(domNode3).addClass('chat-call__video--is-active');
                    });
                }
                if ("enter" === node3Status) {
                    call(domNode2, myPeer, node2Code, stream);
                }
            }
        })
        .catch(function(err) {
            alert('Webcam ou microfone não detectados.');
        });

        $('[data-call-src]').on('click', function(e) {
            e.preventDefault();
            $('[data-call-src]').removeClass('chat-call__video--is-active');
            $(this).addClass('chat-call__video--is-active');
            if (number < 3) {
                var streamActive = $('video', this).get(0).srcObject;
                streamActive.muted = false;
                addStreamToDOM(domMaster, 'master', streamActive, true);
            }
            return false;
        });
    });
});